import React from 'react';
import { AppBar, Toolbar, Button, Box, Typography, useTheme } from '@mui/material';
import { Download } from '@mui/icons-material';

const TopNav = ({ onOpenInstallPrompt }) => {
  const theme = useTheme();
  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: 'white',
        boxShadow: 'none',
        borderBottom: '1px solid',
        borderColor: 'divider',
        zIndex: 1100,
        height: '48px',
      }}
    >
      <Toolbar sx={{ justifyContent: 'center', minHeight: '48px !important' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: theme.palette.primary.dark }}>
          Install Our App 
          <Button
            variant="contained"
            startIcon={<Download />}
            onClick={onOpenInstallPrompt}
            sx={{
              textTransform: 'none',
              fontWeight: 'bold',
              bgcolor: theme.palette.primary.main,
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
              },
            }}
          >
            <Typography variant="button">Install App</Typography>
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopNav;